import React from "react"
function HelloWorld()
{
    return (
        <div>
           <h1>HELLO WORLD!</h1>
        </div>
    );
}
export default HelloWorld;